/* global window */

export const DEFAULT_DATA_GRID_LIMIT: number = 10;
export const DATA_GRID_LIMIT_LOCAL_SESSION_KEY: string = 'items_shown_per_page';
export const DEFAULT_OFFSET: number = 0;
export const DEFAULT_COUNT_API_LIMIT: number = 100;

// A frontend type well-suited for passing in to DataGrid (which uses page and pageSize)
export interface IPaginationParams {
  page: number;
  pageSize: number;
  sortField?: string;
  search?: string;
  sortDirection?: 'asc' | 'desc';
  filters?: Record<string, any>;
}

// A backend type well-suited for passing in to Sequelize (which uses limit and offset)
export interface IPagedQueryParams {
  limit?: string;
  offset?: string;
}

export interface ISortQueryParams {
  sortField?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface IPagedSortedQueryParams extends IPagedQueryParams, ISortQueryParams {}

export interface IFilter {
  field: string;
  bucketId?: string;
  operator?: string;
  value: any;
}

export interface IFilterQueryParams {
  filters?: string;
}

export interface IPaginatedAPIResponse<T> {
  count: number;
  rows: T[];
}

export const HIDDEN_ID_CELL = {
  field: 'id',
  headerName: 'ID',
  sortable: false,
  hide: true // For DataGrid component use columnVisibilityModel prop to hide a column
};

export const HIDDEN_CREATED_AT_CELL = {
  field: 'created_at',
  headerName: 'Created At',
  sortable: true,
  hide: true // For DataGrid component use columnVisibilityModel prop to hide a column
};

export const DEFAULT_PAGED_SORTED_QUERY_PARAMS: IPagedQueryParams = {
  limit: '25',
  offset: '0'
};

export function getDefaultGridPageSize() {
  const storedLimitValue = parseInt(window.localStorage.getItem(DATA_GRID_LIMIT_LOCAL_SESSION_KEY) || '');

  if (!isNaN(storedLimitValue)) {
    return storedLimitValue;
  }

  return DEFAULT_DATA_GRID_LIMIT;
}

export function getChipCountText(count: number) {
  return count < DEFAULT_COUNT_API_LIMIT ? count : `${DEFAULT_COUNT_API_LIMIT - 1}+`;
}
